var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simple-history',{attrs:{"histories":_vm.histories,"functionCategory":_vm.functionCategory}})}
var staticRenderFns = []

export { render, staticRenderFns }